import React from 'react'

const Events = () => {
  return (
    <div className='padding-top'>Coming Soon</div>
  )
}

export default Events